import { toastService } from "src/libraries/toast";
import { forceUpdateService } from "../entity/platforms/ForceUpdateService";
import { UpdatePlatformDto } from "../entity/platforms/dto/update-platform-dto";

export const updateForceUpdateUseCase = async (payload: UpdatePlatformDto) => {
    try {
        const response = await forceUpdateService.update(payload);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            return response.data;
        }
    } catch (error) {
        console.warn('updateForceUpdateUseCase: ', error);
    };
};
